<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="list"></a></div>
<h4 class="fronthead">I<span class="sc">LLUSTRATIONS</span></h4>
<p class="center"><img alt="" src="html/docimages/image1.jpg" width="100%"/></p>
<p class="textbreak"><span href="#/html/043_p1#plates1" id="plate1" title="Link target outside of Sample">Jessie’s mother’s birth certificate</span></p>
<p class="toc"><span href="#/html/044_p2#plates2" id="plate2" title="Link target outside of Sample">Four generations of the Power family</span></p>
<p class="toc"><span href="#/html/045_p3#plates3" id="plate3" title="Link target outside of Sample">Granny Riley</span></p>
<p class="toc"><span href="#/html/046_p4#plates4" id="plate4" title="Link target outside of Sample">Granny Power</span></p>
<p class="toc"><span href="#/html/047_p5#plates5" id="plate5" title="Link target outside of Sample">Granny Riley and Auntie Maggie</span></p>
<p class="toc"><span href="#/html/048_p6#plates6" id="plate6" title="Link target outside of Sample">Jessie’s father aged 15</span></p>
<p class="toc"><span href="#/html/049_p7#plates7" id="plate7" title="Link target outside of Sample">A gathering of relatives at ‘The Berries’</span></p>
<p class="toc"><span href="#/html/050_p8#plates8" id="plate8" title="Link target outside of Sample">Jessie’s mother and father in 1940</span></p>
<p class="toc"><span href="#/html/051_p9#plates9" id="plate9" title="Link target outside of Sample">Jessie’s mother and Uncle Charlie</span></p>
<p class="toc"><span href="#/html/052_p10#plates10" id="plate10" title="Link target outside of Sample">Jessie’s father</span></p>
<p class="toc"><span href="#/html/053_p11#plates11" id="plate11" title="Link target outside of Sample">Jessie’s mother with her older sisters</span></p>
<p class="toc"><span href="#/html/054_p12#plates12" id="plate12" title="Link target outside of Sample">The bus and the ‘wee Fordy van’</span></p>
<p class="toc"><span href="#/html/055_p13#plates13" id="plate13" title="Link target outside of Sample">Jessie’s mother and father with three of her older sisters</span></p>
<p class="toc"><span href="#/html/056_p14#plates14" id="plate14" title="Link target outside of Sample">Jessie, eight months old</span></p>
<p class="toc"><span href="#/html/057_p15#plates15" id="plate15" title="Link target outside of Sample">Jessie’s mother and Uncle Wullie</span></p>
<p class="toc"><span href="#/html/058_p16#plates16" id="plate16" title="Link target outside of Sample">Mona, Chrissy, Shirley and Janey</span></p>
<p class="toc"><span href="#/html/059_p17#plates17" id="plate17" title="Link target outside of Sample">Jess in her school uniform</span></p>
<p class="toc"><span href="#/html/060_p18#plates18" id="plate18" title="Link target outside of Sample">Jess with her mother, Jeannie</span></p>
<p class="toc"><span href="#/html/061_p19#plates19" id="plate19" title="Link target outside of Sample">Jess with her father, Charlie</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_list.vue?12d9ddae